import React, { useState, useCallback, useEffect, useRef, Children } from "react";
import {
  _getBaseUrl,
} from "../utils/helper";

const Modal = (props) => {
  return (
    <React.Fragment>

      {
        props.blockPage && <div className="fixed top-0 left-0 bottom-0 right-0 bg-white bg-opacity-70 z-40" onClick={() => { props.onCancel(); }}></div>
      }
    
      <div className={`${props.position ? props.position : 'fixed'} w-[90vw] sm:w-auto z-50 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg rounded-lg px-16 py-12 max-w-lg overflow-hidden`}>
        <div className="grid gap-4">
          <h3 className="h4 font-sharpgrotesk text-center">
            {props.title}
          </h3>
          
          { props.children }

          {
            props.errorMessage && <div className="text-center text-red-700 text-sm">{props.errorMessage}</div>
          }

          <div className="flex flex-wrap sm:flex-nowrap justify-center gap-4">
            <button
              type="button"
              className="w-full sm:w-auto text-base rounded-full py-3 px-5 border border-cirBlack bg-white cursor-pointer hover:bg-cirBlack hover:text-white"
              onClick={() => {
                props.onCancel();
              }}
            >
              Annuleren
            </button>
            <button
              type="button"
              className={`w-full sm:w-auto text-base rounded-full py-3 px-5 cursor-pointer border 
              ${props.confirmButtonCss ? props.confirmButtonCss : 'border-cirBlack bg-cirBlack text-white hover:bg-white hover:text-cirBlack'}`}
              onClick={() => {
                props.onConfirm();
              }}
            >
              { props.confirmButtonLabel }
            </button>
          </div>
        </div>

        {props.isProcessing && (
          <div className="absolute top-0 left-0 bg-white w-full h-full bg-opacity-75 flex items-center justify-center">
            <img
              src={_getBaseUrl("src/assets/loading.gif", true)}
              alt="Loading"
              className="scale-50"
            />
          </div>
        )}
      </div>

    </React.Fragment>
  );
};

export default Modal;
